module.exports = __webpack_public_path__ + "static/media/Slice11@2x.2e2c8c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_209/images/Slice11@2x.png
// module id = 1733
// module chunks = 0